import { useMemo, useQuery, useEffect } from 'sb-hooks'
import { useConnect } from 'sb-redux-hook'
import queueActions from 'redux/models/queue/actions'

import type { AddToProduct } from 'components/_new/controls'

import productsOfMonthQuery from './productsOfMonth.graphql'


type ReturnData = {
  data: AddToProduct | null
  year: number
  month: number
  isFetching: boolean
}

const useNextProduct = (productToAdd?: AddToProduct): ReturnData => {
  const { isQueueFetching, isQueueFetched, queueItems, gender } = useConnect({
    isQueueFetching: 'models.queue.isFetching',
    isQueueFetched: 'models.queue.isFetched',
    queueItems: 'models.queue.items',
    gender: 'models.me.gender',
  })

  useEffect(() => {
    if (!isQueueFetched && !isQueueFetching) {
      queueActions.fetch()
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const { month, year, queueProduct } = useMemo(() => {
    const nextMonth = queueItems.find(({ disabled }) => !disabled)
    const { month, year, products } = nextMonth || {}

    return {
      month,
      year,
      queueProduct: products && products[0] && products[0].id ? products[0] : null,
    }
  }, [ queueItems ])

  const pomOptions = useMemo(() => ({
    name: 'productOfMonth',
    variables: {
      // TODO what a hooey, why not gender? - added on 03.06.2020 by sonatskiy
      groupId: gender === 'male' ? 'Colognes' : 'Perfumes',
      yearMonth: `${year}-${month}`,
    },
    modifyResult: ({ productsOfMonth }) => productsOfMonth && productsOfMonth[0] && productsOfMonth[0].product,
    skip: Boolean(productToAdd || queueProduct || !isQueueFetched),
    cache: true,
  }), [ productToAdd, queueProduct, gender, year, month, isQueueFetched ])

  const { data: pomData, isFetching } = useQuery(productsOfMonthQuery, pomOptions)

  const data = useMemo(() => {
    if (productToAdd) {
      return productToAdd
    }

    if (queueProduct) {
      return queueProduct
    }

    if (pomData) {
      return pomData
    }

    return null
  }, [ productToAdd, queueProduct, pomData ])

  return {
    data,
    year,
    month,
    isFetching: isQueueFetching || isFetching,
  }
}


export default useNextProduct
